<template>
  <div class="flex min-h-screen max-h-screen flex-col overflow-hidden bg-white">
    <Navbar />
    <AlertBanner root />
    <div class="flex flex-1 relative">
      <SideNav class="hidden tablet-h:flex" />
      <slot />
      <Sidebar
        v-if="sidebar"
        class="hidden tablet-h:flex tablet-h:absolute top-0 right-0 bottom-0 desktop:static"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Navbar from '@/shared/components/Navbar.vue'
import AlertBanner from '@/shared/components/AlertBanner.vue'
import SideNav from '@/shared/components/SideNav.vue'
import Sidebar from '@/features/explorer/components/Sidebar.vue'

withDefaults(
  defineProps<{
    sidebar?: boolean
  }>(),
  {
    sidebar: false,
  }
)
</script>
